import type { Appointment, Pin, Snooze } from "models";

export type ItemWithHistory<T> = T & { history: T[]; appointment?: Appointment };

export const groupAndSortItemsWithHistory = <T extends Pin | Snooze>(items?: T[] | null) => {
  if (!items) return [];

  const interventions = new Map<number, ItemWithHistory<T>>();
  const questions = new Map<number, ItemWithHistory<T>>();

  const updateMap = (map: Map<number, ItemWithHistory<T>>, id: number, item: T) => {
    const mapItem = map.get(id);
    if (mapItem) {
      if (item.created_on > mapItem.created_on) {
        mapItem.history.unshift(item);
        map.set(id, { ...item, history: mapItem.history });
        mapItem.history = [];
      } else mapItem.history.push(item);
    } else map.set(id, { ...item, history: [item] });
  };

  items.forEach(i => {
    if (i.intervention_id) updateMap(interventions, i.intervention_id, i);
    else if (i.question_result_id) updateMap(questions, i.question_result_id, i);
  });

  return [...interventions.values(), ...questions.values()].sort((a, b) => ((b.appointment?.time_car_app ?? 0) > (a.appointment?.time_car_app ?? 0) ? 1 : -1));
};
